import React from 'react'
import {Close} from '@mui/icons-material'
import * as RadixDialog from '@radix-ui/react-dialog'
import {twMerge} from 'tailwind-merge'

export const DialogClose = React.forwardRef


(({className, ...props}, ref) => (
  React.createElement(RadixDialog.Close, { asChild: true,}
    , React.createElement('button', {
      ref: ref,
      className: twMerge(
        'absolute top-4 right-4 inline-flex h-6 w-6 cursor-pointer appearance-none items-center justify-center bg-transparent',
        className
      ),
      'aria-label': "Close",
      ...props,}

      , React.createElement(Close, { className: "text-slate-500 hover:opacity-50" ,} )
    )
  )
))
